import React, { useEffect, useState, useCallback } from 'react';
import { Tabs, Tab, Box, IconButton, Tooltip, CircularProgress } from '@mui/material';
import ApprovalTrackerGrid from '../../components/Estimator/ApprovalTracker';
import InProgressGrid from '../../components/Estimator/InProgressGrid';

const EstimateManagement = () => {
  const [pendingRequests, setPendingRequests] = useState([]);
  const [awardedRequests, setAwardedRequests] = useState([]);
  const [activeTab, setActiveTab] = useState(0);

  const tabConfig = [
    {
      label: `In Progress Estimates`,
      component: <InProgressGrid />,
    },
    {
      label: `Pending Approval (${pendingRequests.length})`,
    },
    {
      label: `Approved Estimates`,
    },
    {
      label: `Approval Progress`,
      component: <ApprovalTrackerGrid />,
    },
  ];

  const handleTabChange = (e, newValue) => setActiveTab(newValue);

  return (
    <Box sx={{ width: '100%', padding: '20px' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          sx={{
            '& .MuiTab-root': {
              minWidth: '180px',
              fontSize: '16px',
              padding: '12px 20px',
              textTransform: 'none',
            },
            '& .MuiTabs-indicator': {
              height: '4px',
              borderRadius: '2px',
            },
          }}
        >
          {tabConfig.map((tab, i) => (
            <Tab key={i} label={tab.label} />
          ))}
        </Tabs>
      </Box>

      <Box sx={{ mt: 2 }}>{tabConfig[activeTab]?.component || null}</Box>
    </Box>
  );
};

export default EstimateManagement;
